import { join, map, prop } from 'rambda';

export const defaultUnitValueSpacer = join(', ');
export const extractValue = map(prop('value'));
